import React from "react";
import "./CannedMsgCard.scss";
import { MdContentCopy } from "react-icons/md";
import _colors from "styles/colors.module.scss";
import CannedMessageService from "services/CannedMessageService";
import { getUsername } from "utils/Common";
import PropTypes from "prop-types";
import { uepClient } from "uepClient";
const { lightBlue } = _colors;

function CannedMsgCard(props) {
  const { message } = props;
  const username = getUsername();

  const copyMessageToActiveConversation = () => {
    CannedMessageService.copyCannedMessage(message);
    recordRecentlyUsedMessage();
  };

  const recordRecentlyUsedMessage = () => {
    uepClient()
      .post(`/user-canned-message/${username}`, { message: message })
      .then(() => {
        console.info("Successfully recorded latest used canned message");
      })
      .catch((error) => {
        console.error(
          `Some error occured while trying to record the latest used canned message: ${error.message}`
        );
      });
  };

  return (
    <div className="canned-message-card">
      <div className="canned-message">{message}</div>
      <div className="copy-div">
        <MdContentCopy
          className="copy-msg-icon"
          color={lightBlue}
          size="15"
          onClick={copyMessageToActiveConversation}
        />
      </div>
    </div>
  );
}

CannedMsgCard.propTypes = {
  message: PropTypes.string.isRequired,
};

export default CannedMsgCard;
